import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const DashboardRequired = ({ entryData,selfJoinValue }: any) => {
  const totalSteps = 6;
  const [isLoading, setIsLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const finallyStep = currentStep <= 6;
  const stautsTitle = (status: number) => {
    if (status === 0) {
      return '매장정보';
    } else if (status === 1) {
      return '배달정보';
    } else if (status === 2) {
      return '상품정보';
    } else if (status === 3) {
      return '호텔입점관리';
    } else if (status === 4) {
      return '주문접수 프로그램 설치';
    } else if (status === 5) {
      return '영업개시';
    }
  };

  const statusContentList = [
    [
      { key: 'isStoreNameEnSet', name: '영문 매장명', category: 'store', link: '/store/info' },
      { key: 'isLogiImageSet', name: '로고 이미지', category: 'store', link: '/store/info' },
      {
        key: 'isDescriptionExtraSet',
        name: '원산지 표기 사항',
        category: 'store',
        link: '/store/info',
      },
      { key: 'isOpenTimeSet', name: '영업 시간 등록', category: 'store', link: '/store/time' },
      { key: 'isOwnerAccountSet', name: '사장님 계좌 정보', category: 'store', link: '/ceo/info' },
    ],
    [
      {
        key: 'isDeliveryEstimatedTimeSet',
        name: '배달 도착 예상 시간',
        category: 'delivery',
        link: '/store/delivery',
      },
      {
        key: 'isLimitOrderPriceSet',
        name: '최소 주문 금액',
        category: 'delivery',
        link: '/store/delivery',
      },
      {
        key: 'isBaseDeliveryPriceSet',
        name: '기본 배달팁',
        category: 'delivery',
        link: '/store/delivery',
      },
    ],
    [
      {
        key: 'isStoreCategorySelected',
        name: '매장 업종 선택',
        category: 'product',
        link: '/advertise/category',
      },
      {
        key: 'isCategorySet',
        name: '상품 분류 등록',
        category: 'product',
        link: '/product/category',
      },
      { key: 'isProductSet', name: '상품 등록', category: 'product', link: '/product/product' },
    ],
    [
      {
        key: 'isRegisteredHotel',
        name: '호텔 입점 신청',
        category: 'hotel',
        link: '/advertise/status',
      },
    ],
    [{ key: 'isOnboaded', name: '포스설치', category: 'program', link: '/notification/posguide' }],
    [
      {
        key: 'isCompletedTestOrder',
        name: '테스트주문',
        category: 'storeOpen',
        link: selfJoinValue ? '/store/self/testOrder': '/store/testOrder',
      },
    ],
  ].map((group) =>
    group.map((item) => ({
      ...item,
      value: entryData[item.category]?.[item.key] ?? false,
    })),
  );
  useEffect(() => {
    let step = 1;
    if (finallyStep) {
      for (const group of statusContentList) {
        const isGroupComplete = group.every((item) => item.value === true);
        if (!isGroupComplete) break;
        step++;
      }
      setCurrentStep(step);
      setIsLoading(false);
    }
  }, [entryData]);
  if (isLoading) return null;

  return (
    <Style>
      <div className="requiredContainer">
        {finallyStep ? (
          <div className="titleBox">
            <img src={`${process.env.PUBLIC_URL}/img/warning.png`} alt="warning" width={24} />
            <p>사장님 영업 시작을 위해 필수입력 항목을 입력해주세요!</p>
          </div>
        ) : (
          <div
            style={{ background: 'none', fontSize: '18px', color: '#aaa', fontWeight: '600' }}
            className="titleBox success">
            사장님! 영업 시작을 위한 모든 필수 입력이 완료되었어요😊
          </div>
        )}
        <div className="statusBarWrap number">
          {Array.from({ length: totalSteps }, (index, i) => (
            <div className="statusItem" key={i}>
              <div className={`statusNumber ${i + 1 <= currentStep && 'active'}`}>{i + 1}</div>
              <h2>{stautsTitle(i)}</h2>
            </div>
          ))}
        </div>
        <div className="statusBarWrap content">
          {statusContentList.map((contents, i) => (
            <div
              key={i}
              className={`statusContent ${
                i + 1 === currentStep ? 'active' : i + 1 < currentStep ? 'success' : ''
              }`}>
              {contents.map((content, idx) => (
                <Link to={content.link} key={idx} className="contentText">
                  <p className={`statusText ${content.value && 'success'}`}>{content.name}</p>
                  {i + 1 === currentStep && !content.value && (
                    <button>{i < 3 ? '입력하기' : '바로가기'}</button>
                  )}
                  {content.value && (
                    <>
                      <img src={`${process.env.PUBLIC_URL}/img/check.png`} alt="check" width={14} />
                      <h4 className="successText">완료</h4>
                    </>
                  )}
                </Link>
              ))}
            </div>
          ))}
        </div>
      </div>
    </Style>
  );
};

export default DashboardRequired;

const Style = styled.div`
  /* requiredContainer */
  .requiredContainer {
    width: 100%;
    padding: 12px 20px;
  }

  /* titleBox */
  .titleBox {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 40px;
    padding: 10px 0;
    border-radius: 4px;

    p,
    img {
      font-size: 18px;
      font-weight: 600;
      color: #ff6060;
      animation: blink 2s 3;
    }
  }

  .statusBarWrap {
    width: 100%;
    flex: 1;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    align-self: center;
  }
  .statusBarWrap.number {
  }
  .statusBarWrap.content {
    gap: 6px;
  }
  .statusNumber {
    color: #ddd;
    font-size: 40px;
    font-weight: 700;
  }
  .statusItem {
    width: 100%;

    h2 {
      margin: 20px 0 14px 0;
      font-size: 18px;
      font-weight: 700;
      color: #333;
    }
  }
  .line {
    height: 2px;
    flex-grow: 1;
    margin: 0 8px;
    background: #ddd;
  }
  .statusNumber.active {
    color: #4dd2ae;
  }

  .statusContent {
    flex: 1;
    height: 170px;
    padding: 10px;
    background: #f9f9f9;
    border-radius: 4px;

    p {
      white-space: nowrap;
      font-size: 14px;
      line-height: 28px;
      color: #333;
    }
  }
  .statusContent.active {
    background: #4dd2ae;
    border: 2px solid #40977f;
    p {
      font-weight: 500;
      color: #fff;
    }
    .statusText.success {
      color: #888;
      font-weight: 400;
    }
    .successText {
      color: #40977f;
    }
  }
  .statusContent button {
    background: #ff6060;
    font-size: 12px;
    line-height: 20px;
    border-radius: 4px;
    color: #fff;
    font-weight: 500;
  }
  .statusText.success {
    background: none;
    text-decoration-color: #999;
    color: #888;
  }
  .success {
    background: #d9f1ea;
    p {
      color: #aaa;
    }
  }
  .successText {
    font-size: 10px;
    color: #4dd2ae;
  }
  .contentText {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  @keyframes blink {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }

  @media (max-width: 1500px) {
    .requiredContainer {
      padding: 10px;
    }
    .statusItem h2 {
      font-size: 16px;
    }
    .contentText {
      gap: 4px;
    }
    .contentText p {
      font-size: 12px;
    }
    .statusContent {
      height: 180px;
    }
    .statusContent button {
      padding: 0 4px;
      font-size: 10px;
    }
  }
  @media (max-width: 900px) {
    .requiredContainer {
      padding: 0;
    }
    .titleBox {
      margin-bottom: 10px;
      p {
        font-size: 16px;
      }
      img {
        width: 16px;
      }
    }
    .statusItem {
      display: none;
    }
    .statusBarWrap {
      flex-direction: column;
    }
  }
`;
